import { useAppSelector } from "../../../../logic/src/redux";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { ChangeRequestResultPage } from "../ChangeRequestResultPage";
import { DefaultStepProps } from "../Stepper/CustomStepper";

export const ChangeRequestSentPage: React.FC<DefaultStepProps> = () => {
    const { t } = useTypedTranslation();
    const isChangeFundsRequestSuccessful = useAppSelector((state) => state.stepper.isChangeFundsRequestSuccessful); //Check if the request on SMSVerificationPage was successful
    const isLoading = isChangeFundsRequestSuccessful === null;

    if (isLoading) {
        return <ChangeRequestResultPage status="success" isLoading />;
    }

    if (isChangeFundsRequestSuccessful) {
        return <ChangeRequestResultPage status="success" />;
    }

    return (
        <ChangeRequestResultPage
            status="failed"
            bodyText={t("changeRequestResult.failed.body")}
            bodyVariant="plain"
        />
    );
};
